import * as React from 'react';
import { ReactComponentElement } from 'react';

interface Props {
  icon: ReactComponentElement<any>;
  title: string;
}

export const CardHeader: React.FC<Props> = ({ icon, title }) => (
  <div className='mb-6 flex items-center gap-2'>
    {React.cloneElement(icon, { className: 'h-5 w-5 text-gray-500' })}
    <h2 className='text-xl font-bold'>{title}</h2>
  </div>
);
